import { Popup } from '@silverfort/sf-components';
import { FC } from 'react';
import RiskEntitiesPopupContent from './RiskEntitiesPopupContent';

interface Props {
    open: boolean;
    onClose: () => void;
}

const RiskEntitiesPopup: FC<Props> = ({ open, onClose }) => {
    return (
        <Popup
            open={open}
            title="Entities by Risk"
            ContentComponent={RiskEntitiesPopupContent}
            FooterComponent={() => null}
            onClose={onClose}
            popupClassName="min-w-[824px] h-[70vh] max-w-full font-sf"
        />
    );
};

export default RiskEntitiesPopup;
